import React, { useEffect, useRef } from 'react';
import { SupportedPaymentMethods } from '../../services/ApplicationSession';
var ApplePay = function (props) {
    var applePayRef = useRef(null);
    var applePayInputRef = useRef(null);
    // for some reason, onSubmit callback is being called first before onAuthorized in adyen's code.
    // so we need to wait for onAuthorized to be called to fetch the billingContact from apple pay
    var callback = function (state) {
        var _a;
        applePayInputRef.current = {
            encryptedCustomerInput: state.data.paymentMethod,
            paymentType: SupportedPaymentMethods.WEB_DROP_IN_APPLE_PAY,
            riskData: (_a = state.data) === null || _a === void 0 ? void 0 : _a.riskData
        };
    };
    var onAuthorized = function (resolve, reject, event) {
        var _a;
        var billingContact = event.payment.billingContact;
        var billingInformation = {
            contact: {
                email: billingContact.emailAddress,
                firstName: billingContact.givenName,
                lastName: billingContact.familyName
            },
            address: {
                address1: billingContact.addressLines[0],
                address2: billingContact.addressLines[1],
                stateOrProvince: billingContact.administrativeArea,
                postalCode: billingContact.postalCode,
                city: billingContact.locality
            }
        };
        props.applicationSession.config.billingInformation = billingInformation;
        if (applePayInputRef.current) {
            applePayInputRef.current.billingInformation = billingInformation;
            (_a = props === null || props === void 0 ? void 0 : props.onAuthorized) === null || _a === void 0 ? void 0 : _a.call(props, applePayInputRef.current, undefined);
        }
        resolve();
    };
    useEffect(function () {
        props.applicationSession.initializeApplePay(applePayRef, callback, onAuthorized, props.onProcessing);
    }, []);
    return React.createElement("div", { ref: applePayRef, id: 'applepay-container' });
};
export default ApplePay;
